import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-intro-card',
  templateUrl: './intro-card.component.html',
  styleUrls: ['./intro-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatIcon],
})
export class IntroCardComponent {
  @Input() title: string;

  @Input() content: string | number;

  @Input() icon: string;
}
